<div class="proposal-customer-info-container" [formGroup]="proposalCustomerInfoForm">
    <label>
        {{ 'PROPERTIES_CUSTOMER_INFO_LABEL' | translate }}
    </label>
    <fieldset>
        <legend>
            {{ 'PROPERTIES_CUSTOMER_CONTACT_LEGEND' | translate }}
        </legend>
        <div class="customer-container">
            <label>
                {{ 'PROPERTIES_CUSTOMER_CONTACT_DESCRIPTION' | translate }}
            </label>
            <div class="customer-grid">
                <label>
                    {{ 'PROPERTIES_CUSTOMER_CONTACT_NAME_LABEL' | translate }}:
                </label>
                <mat-form-field appearance="outline">
                    <input matInput formControlName="name" />
                </mat-form-field>
            </div>
        </div>
    </fieldset>
    <fieldset>
        <legend>
            {{ 'PROPERTIES_CUSTOMER_OVERRIDE_LEGEND' | translate }}
        </legend>
        <div class="customer-container">
            <label>
                {{ 'PROPERTIES_CUSTOMER_OVERRIDE_DESCRIPTION' | translate }}
            </label>
            <mat-radio-group formControlName="customerOverrideOption">
                <mat-radio-button class="radio-btn" color="primary" [value]="true">
                    <label>
                        {{'PROPERTIES_CUSTOMER_OVERRIDE_USE_CUSTOM' | translate }}
                    </label>
                </mat-radio-button>
                <ng-container>
                    <div class="customer-grid">
                        <label class="label-padding">{{ 'PROPERTIES_CUSTOMER_OVERRIDE_ACCOUNT_NAME' | translate
                            }}:</label>
                        <mat-form-field appearance="outline">
                            <input matInput formControlName="customAccountName" />
                        </mat-form-field>
                    </div>
                </ng-container>
                <mat-radio-button class="radio-btn" color="primary" [value]="false">
                    <label>
                        {{'PROPERTIES_CUSTOMER_OVERRIDE_USE_SIESALES' | translate }}
                    </label>
                </mat-radio-button>
                <ng-container>
                    <div class="customer-grid">
                        <label class="label-padding">
                            {{ 'PROPERTIES_CUSTOMER_OVERRIDE_ACCOUNT_NAME' | translate }}:
                        </label>
                        {{accountName}} 
                    </div>
                    <div class="customer-grid">
                        <label class="label-padding">
                            {{ 'PROPERTIES_CUSTOMER_OVERRIDE_ADDRESS1' | translate }}:
                        </label>
                        {{address1}}
                    </div>
                    <div class="customer-grid">
                        <label class="label-padding">
                            {{ 'PROPERTIES_CUSTOMER_OVERRIDE_ADDRESS2' | translate }}:
                        </label>
                        {{address2}}
                    </div>
                    <div class="customer-grid">
                        <label class="label-padding">
                            {{ 'PROPERTIES_CUSTOMER_OVERRIDE_CITY' | translate }}:
                        </label>
                        {{city}}
                    </div>
                    <div class="customer-grid">
                        <label class="label-padding">
                            {{ 'PROPERTIES_CUSTOMER_OVERRIDE_STATE' | translate }}:
                        </label>
                        {{state}}
                    </div>
                    <div class="customer-grid">
                        <label class="label-padding">
                            {{ 'PROPERTIES_CUSTOMER_OVERRIDE_ZIP_CODE' | translate }}:
                        </label>
                        {{zipCode}}
                    </div>
                </ng-container>
            </mat-radio-group>
        </div>
    </fieldset>
</div>